import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Helps } from 'src/app/libs/helps';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard  {
  constructor(private router: Router, private helps:Helps) {}
  canActivate(route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot) {
    const token = this.helps.getToken();
    const level: number = Number(token?.level) ?? 0;
    console.log("AdminGuard: level->", level);

    // ADMINISTRADOR (level 99) → Acceso completo
    if (level === 99) {
      return true;
    }

    // CENTRALISTA (level 50) → Solo acceso a central-de-seguridad
    if (level === 50) {
      if (state?.url?.includes('/central-de-seguridad')) {
        return true;
      } else {
        this.router.navigate(['/central-de-seguridad']);
        return false;
      }
    }

    // SUPERVISOR (level 2) → No puede acceder a rutas admin
    if (level === 2) {
      console.log("AdminGuard: SUPERVISOR no puede acceder a rutas admin");
      this.router.navigate(["/supervisor"]);
      return false;
    }

    // Otros niveles → Redirigir a login
    console.log("AdminGuard: Acceso denegado para level:", level);
    this.router.navigate(["/login"]);
    return false;
  }
}
